import * as types from './actionTypes';
import reportApi from '../api/reportApi';

export const fetchReports = () => ({
  type: types.FETCH_REPORTS
});

export const fetchReportsSuccess = reports => ({
  reports,
  type: types.FETCH_REPORTS_SUCCESS
});

export const fetchReportsError = () => ({
  type: types.FETCH_REPORTS_ERROR
});

export const exportStudents = (filters, type, title) =>
  () =>
    reportApi.exportStudents(filters, type, title);

export const getReports = () =>
  (dispatch) => {
    dispatch(fetchReports());
    reportApi.getReports().then(({ reports }) => {
      dispatch(fetchReportsSuccess(reports));
    }).catch(() => dispatch(fetchReportsError()));
  };

export const exportStudentProfile = id =>
  () =>
    reportApi.exportStudentPdf(id);



// WEBPACK FOOTER //
// ./src/actions/reportActions.js